import { toast } from "sonner";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const originalFetch = window.fetch;
let lastRateLimitToast = 0;

window.fetch = async (...args: Parameters<typeof fetch>) => {
  const response = await originalFetch(...args);

  const url =
    typeof args[0] === "string"
      ? args[0]
      : args[0] instanceof Request
        ? args[0].url
        : "";

  if (response.status === 429 && url.startsWith(API_BASE_URL)) {
    const now = Date.now();
    if (now - lastRateLimitToast > 5000) {
      lastRateLimitToast = now;
      toast.warning("Slow down", {
        description: "Too many requests. Please wait and try again.",
      });
    }
  }

  return response;
};
